module.exports = __webpack_public_path__ + "static/our-partners-700f73dc3b758342b544269a7a30be43.png";